const INTERNAL_PATH_REGEX = /^\//;
const EXTERNAL_URL_REGEX = /^https?:\/\//i;

export const getInternalPath = (url) => {
  if (typeof url !== 'string') return null;

  const trimmed = url.trim();
  if (!trimmed || !INTERNAL_PATH_REGEX.test(trimmed)) return null;

  return trimmed.split('#')[0].split('?')[0] || null;
};

export const resolveLegalLink = (url, legalRouteMap = {}) => {
  const href = typeof url === 'string' ? url.trim() : '';

  if (!href) {
    return {
      href: '#',
      mode: 'empty',
    };
  }

  if (EXTERNAL_URL_REGEX.test(href)) {
    return {
      href,
      mode: 'external',
    };
  }

  const internalPath = getInternalPath(href);
  if (!internalPath) {
    return {
      href,
      mode: 'external',
    };
  }

  const legalEntry = legalRouteMap?.[internalPath];

  if (legalEntry?.fileUrl) {
    return {
      href: legalEntry.fileUrl,
      mode: 'file',
      path: internalPath,
    };
  }

  return {
    href,
    mode: 'page',
    path: internalPath,
  };
};